module.exports = __webpack_public_path__ + "img/badge_conv_request_form.7dac1637.png";